/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, registerables, ArcElement } from 'chart.js';
Chart.register(...registerables);
Chart.register(ArcElement);

const options = {
    responsive: true,
    legend: {
        display: false,
    },
    cutout: 125,

};
export default function Chart_Donught(props) {
const porcentageData = (data) => {
    const total = data[0] + data[2];
    const percentageA = (total * 100) / data[1] 
    const percentageB = (100 - percentageA) 
    return [percentageA, percentageB]
}    

const chartData = porcentageData(props.data);
const showData = chartData[0] + '%';
const data = {
    labels: [],
    datasets: [
        {
            data: chartData,
            backgroundColor: ['#e84671', '#eba9b8'],
            barPercentage: 0.9,
            borderWidth: 0,
            radius: 145,
        },
    ],
    text: showData,
};


    return (
        <div>
            <Doughnut data={data} options={options} height={250} />
        </div>
    );
}
